import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import './styles/tend.css';
import App from './App';

// Suppress benign ResizeObserver error (common with complex layouts/video players)
// This error is harmless and occurs when ResizeObserver can't deliver all notifications in one frame
const isResizeObserverError = (msg: string) =>
  msg?.includes('ResizeObserver loop') ||
  msg?.includes('ResizeObserver loop completed with undelivered notifications') ||
  msg?.includes('ResizeObserver loop limit exceeded');

// Suppress via window error event
window.addEventListener('error', (e: ErrorEvent) => {
  if (isResizeObserverError(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
}, true);

// Suppress via unhandled promise rejection
window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
  if (isResizeObserverError(e.reason?.message || String(e.reason))) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

// Override console.error to filter out ResizeObserver noise
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  if (args.some(arg => isResizeObserverError(String(arg)))) {
    return; // Suppress ResizeObserver errors from console
  }
  originalConsoleError.apply(console, args);
};

// Integrated demo showing the content flow through all three systems (currently unused)
/*
const IntegratedSystemsDemo = () => {
  // Component implementation commented out for now
};
*/

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);